
import li from '../assets/Link.png';
import gm from '../assets/gmail.png';
import ph from '../assets/phone.png';
export const contactInfo = [
    { title: 'Linkedin', info: 'https://www.linkedin.com/in/esau-lopez-1a5700b9', img: li },
    { title: 'Email', info: 'esaulopezdevs@gmail.com', img: gm },
    { title: 'Phone number', info: '951-445-3740', img: ph }
]
